<template>
	<div>
		<div style="display: flex;align-items: center;justify-content: space-between;">
			<a-breadcrumb style="margin: 16px 0">
				<a-breadcrumb-item>主页</a-breadcrumb-item>
				<a-breadcrumb-item>{{selectFirstMenu}}</a-breadcrumb-item>
				<a-breadcrumb-item>{{selectSecondMenu}}</a-breadcrumb-item>
			</a-breadcrumb>
			<div>
				<a-button class="qinang-button-margin" type="primary" icon="plus" @click="tableAdd">新增</a-button>
				<a-button class="qinang-button-margin" icon="edit" @click="tableEdit" :disabled="!tableSelectedRows.length || tableSelectedRows.length !== 1">修改</a-button>
				<a-button class="qinang-button-margin" icon="delete" @click="tableDel">删除</a-button>
				<a-button icon="sync" @click="apiBlackListQueryList">刷新</a-button>
			</div>
		</div>
		
		<a-collapse expandIconPosition="right" activeKey="1">
			<a-collapse-panel key="1" header="产品黑名单查询">
				<div style="display: flex;justify-content: space-between;align-items: center;">
					<div style="width: 30%;display: flex;align-items: center;">
						<div style="width: 100px;">服务商：</div>
						<a-select v-model="query.facilitatorId" show-search option-filter-prop="children" :filter-option="filterOption" style="width: 100%;" placeholder="请选择服务商" allowClear>
							<a-select-option v-for="(item,index) in facilitatorList" :value="item.facilitatorId" :key="index">{{item.facilitatorName}}</a-select-option>
						</a-select>
					</div>
					<div style="display: flex; justify-content: flex-end;">
						<a-button type="primary" icon="search" @click="apiBlackListQueryList">查询</a-button>
					</div>
				</div>
			</a-collapse-panel>
		</a-collapse>
		
		<div class="qinang-card">
			<div style="display: flex;justify-content: space-between;align-items: center;">
				<a-breadcrumb separator=">" style="padding: 12.5px 16px;" >
					<a-breadcrumb-item>
						黑名单列表
					</a-breadcrumb-item>
				</a-breadcrumb>
			</div>
			<a-table :row-selection="rowSelection" :columns="tableColumns" :data-source="tableData" row-key="blackId" :loading="tableLoading" :pagination="false">

				<span slot="name" slot-scope="text, record">
					<a-button type="link" @click="edit(record)" >{{record.name}}</a-button>
				</span>
				<span slot="facilitatorName" slot-scope="text, record">
					{{facilitatorList.find(item => item.facilitatorId === record.facilitatorId)?.facilitatorName || record.facilitatorId}}
				</span>
			</a-table>
			<a-pagination style="text-align: right;margin: 10px;" :current="query.page" :total="query.total" :default-page-size="query.size" show-size-changer show-quick-jumper size="small" :page-size-options="['10', '20', '50']"
				:show-total="total => `共 ${total} 条记录`" @change="pageChange" @showSizeChange="showSizeChange"/>
		</div>


		<!-- 添加弹窗 -->
		<a-modal class="qa-modal-half" title="添加" width="600px" :visible="addVisible" :confirm-loading="addConfirmLoading" @ok="addHandleOk" @cancel="handleCancel" :maskClosable="false" :keyboard="false" >
			<a-form-model ref="addRuleForm" :model="addForm" :label-col="{span: 5}" :wrapper-col="{span: 17}" :rules="addRules">
				<a-form-model-item label="身份证号" has-feedback prop="cardCode">
					<a-input v-model="addForm.cardCode" placeholder="请输入身份证号" />
				</a-form-model-item>
				<a-form-model-item label="姓名" has-feedback prop="name">
					<a-input v-model="addForm.name" placeholder="请输入姓名" />
				</a-form-model-item>
				<a-form-model-item label="服务商" has-feedback prop="facilitatorId">
					<a-select v-model="addForm.facilitatorId" show-search option-filter-prop="children" :filter-option="filterOption" @change="handleChange" placeholder="请选择服务商">
						<a-select-option v-for="(item,index) in facilitatorList" :value="item.facilitatorId" :key="index">{{item.facilitatorName}}</a-select-option>
					</a-select>
				</a-form-model-item>
				<a-form-model-item label="产品" has-feedback prop="priceId">
					<a-select mode="multiple" v-model="addForm.priceIdList" show-search option-filter-prop="children" :filter-option="filterOption" placeholder="请选择产品" allowClear>
						<a-select-option v-for="(item,index) in priceList" :value="item.priceId" :key="item.priceId">{{item.productName}}</a-select-option>
					</a-select>
				</a-form-model-item>
				<a-form-model-item label="备注">
					<a-textarea v-model="addForm.remark" :rows="3" placeholder="请输入备注" />
				</a-form-model-item>
			</a-form-model>
		</a-modal>

		<!-- 修改弹窗 -->
		<a-modal class="qa-modal-half" title="修改" width="600px" :visible="editVisible" :confirm-loading="editConfirmLoading" @ok="editHandleOk" @cancel="handleCancel" :maskClosable="false" :keyboard="false" >
			<a-form-model ref="editRuleForm" :model="editForm" :label-col="{span: 5}" :wrapper-col="{span: 17}" :rules="addRules">
				<a-form-model-item label="身份证号" has-feedback prop="cardCode">
					<a-input v-model="editForm.cardCode" placeholder="请输入身份证号" />
				</a-form-model-item>
				<a-form-model-item label="姓名" has-feedback prop="name">
					<a-input v-model="editForm.name" placeholder="请输入姓名" />
				</a-form-model-item>
				<a-form-model-item label="服务商" has-feedback prop="facilitatorId">
					<a-select v-model="editForm.facilitatorId" show-search option-filter-prop="children" :filter-option="filterOption" @change="handleEditChange" placeholder="请选择服务商">
						<a-select-option v-for="(item,index) in facilitatorList" :value="item.facilitatorId" :key="index">{{item.facilitatorName}}</a-select-option>
					</a-select>
				</a-form-model-item>
				<a-form-model-item label="产品" >
					<a-select mode="multiple" v-model="editForm.priceIdList" show-search option-filter-prop="children" :filter-option="filterOption" placeholder="请选择产品" allowClear>
						<a-select-option v-for="(item,index) in priceList" :value="item.priceId" :key="item.priceId">{{item.productName}}</a-select-option>
					</a-select>
				</a-form-model-item>
				<a-form-model-item label="备注">
					<a-textarea v-model="editForm.remark" :rows="3" placeholder="请输入备注" />
				</a-form-model-item>
			</a-form-model>
		</a-modal>
		
		
	</div>
</template>

<script>
	import moment from 'moment'
	export default {
		data() {
			return {
				moment,
				selectFirstMenu: window.sessionStorage.getItem('selectFirstMenu'),
				selectSecondMenu: window.sessionStorage.getItem('selectSecondMenu'),
				//服务商列表
				facilitatorList: [],
				//产品列表
				priceList: [],
				// 搜索+表格-start
				query: {
					page: 1,
					size: 10,
					total: 0,
					facilitatorId: undefined,
					cardCode: '',
					name: '',
				},
				mainNavigation:{},
				tableData: [],
				tableColumns: [
                    { title:'ID', dataIndex:'blackId', key:'blackId', align:'center'},
					{ title:'身份证号', dataIndex:'cardCode', key:'cardCode', align:'center'},
					{ title:'姓名', dataIndex:'name', key:'name', align:'center',scopedSlots:{customRender:'name'}},
					{ title:'服务商', key:'facilitatorName', align:'center', scopedSlots:{customRender:'facilitatorName'}},
					{ title:'备注', dataIndex:'remark', key:'remark', align:'center'},
					
				],
				tableLoading: false,
				tableSelectedRows: [],
				//搜索+表格-end
				// 添加弹窗-start
				addVisible: false,
				addConfirmLoading: false,
				addForm: {
					blackId: '',
					cardCode: '',
					name: '',
					facilitatorId: undefined,
					priceId: '',
					priceIdList:[],
					remark: '',
				},
				addRules: {
					cardCode: [{ required: true, message: '身份证号不能为空', trigger: 'blur' }],
					name: [{ required: true, message: '姓名不能为空', trigger: 'blur' }],
					facilitatorId: [{ required: true, message: '请选择服务商', trigger: 'change' }],
					// priceId: [{ required: true, message: '请选择产品', trigger: 'change' }],
				},
				// 添加弹窗-end
				// 修改弹窗-start
				editVisible: false,
				editConfirmLoading: false,
				editForm: {
					blackId: '',
					cardCode: '',
					name: '',
					facilitatorId: undefined,
					priceId: '',
					priceIdList:[],
					remark: '',
				},
				// 修改弹窗-end
			};
		},
		methods: {
			//获取准进设备列表
			async apiFacilitatorList() {
				const {
					data: res
				} = await this.$http.post(this.navigation.apiFacilitatorList, {staffId:window.sessionStorage.getItem('staffId')});
				if (res.code == 200) {
					this.facilitatorList = res.data
					this.apiBlackListQueryList()
				} else {
					this.$message.error(res.msg)
				}
			},

			handleChange(e){
				this.addForm.priceIdList = []
				this.priceList = []
				if(e) {
					this.apiPriceList(e);
				}
			},
			handleEditChange(e){
				// 编辑模式下切换服务商时，清空已选产品
				this.editForm.priceIdList = []
				this.priceList = []
				if(e) {
					this.apiPriceList(e);
				}
			},

			async apiPriceList(facilitatorId){
				const {
					data: res
				} = await this.$http.post(this.navigation.apiPriceList,{facilitatorId:facilitatorId});
				if(res.code == 200){
					this.priceList = res.data
				}

			},

			filterOption(input, option) {
				return (
					option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
				);
			},

			//--------------表格开始-搜索
			async apiBlackListQueryList() {
				this.tableLoading = true
				const {
					data: res
				} = await this.$http.post(this.navigation.apiBlackListQueryList, this.query);
				if (res.code == 200) {
					this.tableData = res.data.list
					this.query.page = res.data.pages.page
					this.query.size = res.data.pages.size
					this.query.total = res.data.pages.total
					// this.$message.success(res.msg)
					this.tableLoading = false
				} else {
					this.$message.error(res.msg)
					this.tableLoading = false
				}
			},
			pageChange(page, pageSize){
				this.query.page = page
				this.query.size = pageSize
				this.apiBlackListQueryList()
			},
			showSizeChange(current, size){
				this.query.page = current
				this.query.size = size
				this.apiBlackListQueryList()
			},
			handleCancel() {
				this.addVisible = false
				this.editVisible = false

			},

			// 添加
			tableAdd() {
				this.addVisible = true
				this.addConfirmLoading = false
				this.addForm = {
					cardCode: '',
					name: '',
					facilitatorId: undefined,
					priceId: '',
					priceIdList:[],
					remark: '',
				}
				this.priceList = []
				if(this.$refs.addRuleForm) {
					this.$refs.addRuleForm.resetFields();
				}
			},
			async apiBlackListAdd() {
				this.addConfirmLoading = true
				this.addForm.priceId = this.addForm.priceIdList.join(',')

				const {
					data: res
				} = await this.$http.post(this.navigation.apiBlackListAdd, this.addForm);
				if (res.code == 200) {
					this.$message.success(res.msg)
					if(this.$refs.addRuleForm) {
						this.$refs.addRuleForm.resetFields();
					}
					this.addConfirmLoading = false
					this.addVisible = false
					// 等待弹窗关闭后再刷新列表
					this.apiBlackListQueryList()
				} else {
					this.$message.error(res.msg)
					this.addConfirmLoading = false
				}
			},
			addHandleOk() {
				this.$refs.addRuleForm.validate(valid => {
					if (valid) {
						this.apiBlackListAdd()
					} else {
						return false;
					}
				});
			},

			// 修改
			async edit(item){
				this.editConfirmLoading = false
				let items = JSON.parse(JSON.stringify(item))
				// 先打开弹窗
				this.editVisible = true
				// 先加载价格列表
				if(items.facilitatorId) {
					await this.apiPriceList(items.facilitatorId)
				}
				// 设置表单数据，确保 priceIdList 属性存在
				this.editForm = {
					...items,
					priceIdList: [] // 先初始化为空数组
				}
				// 使用 $nextTick 确保 DOM 渲染完成后再设置选中值
				await this.$nextTick()
				// 将priceId字符串转换为数组，使用priceList中的实际priceId值进行匹配
				if(items.priceId && this.priceList.length > 0) {
					const savedPriceIds = items.priceId.toString().split(',').map(id => id.trim())
					// 从priceList中找到匹配的priceId，使用实际的值（保持类型一致）
					const matchedPriceIds = this.priceList
						.filter(price => savedPriceIds.includes(String(price.priceId)) || savedPriceIds.includes(String(Number(price.priceId))))
						.map(price => price.priceId)
					this.editForm.priceIdList = matchedPriceIds
				} else {
					this.editForm.priceIdList = []
				}
			},
			async apiBlackListEdit() {
				this.editConfirmLoading = true

				this.editForm.priceId = this.editForm.priceIdList.join(',')
				const {
					data: res
				} = await this.$http.post(this.navigation.apiBlackListEdit, this.editForm);
				if (res.code == 200) {
					this.$message.success(res.msg)
					this.editConfirmLoading = false
					this.editVisible = false
					// 等待弹窗关闭后再刷新列表
					this.apiBlackListQueryList()
				} else {
					this.$message.error(res.msg)
					this.editConfirmLoading = false
				}
			},
			editHandleOk() {
				this.$refs.editRuleForm.validate(valid => {
					if (valid) {
						this.apiBlackListEdit()
					} else {
						return false;
					}
				});
			},
			editHandleCancel() {
				this.editVisible = false
			},
			//删除
			tableDel() {
				let that = this
				if(this.tableSelectedRows.length > 0) {
					const ids = this.tableSelectedRows.map(row=>row.blackId)
					this.$confirm({
						title: '确定要删除当前选中数据吗',
						content: '当前选中' + ids.length + '条数据。',
						okText: '确定',
						okType: 'danger',
						cancelText: '取消',
						onOk() {
							that.apiBlackListDel(ids)
						},
						onCancel() {
						},
					});
				}else{
					this.$message.warning('请选择要删除的数据');
				}
			},
			//删除
			async apiBlackListDel(ids) {
				console.log(ids)
				const {
					data: res
				} = await this.$http.post(this.navigation.apiBlackListDel + '/'+ ids);
				if (res.code == 200) {
					this.$message.success(res.msg)
					await this.apiBlackListQueryList()
				} else {
					this.$message.error(res.msg)
				}
			},
			tableEdit() {
				if(this.tableSelectedRows.length === 1) {
					const item = this.tableData.find(item => item.blackId == this.tableSelectedRows[0].blackId)
					this.edit(item)
				}else{
					this.$message.warning('请选择要修改的数据');
				}
			}
			
		},
		computed: {
			rowSelection() {
				let that = this
				return {
					onChange: (selectedRowKeys, selectedRows) => {
						that.tableSelectedRows = selectedRows;
					},
					// getCheckboxProps: record => ({
					// 	props: {
					// 		disabled: record.name === 'Disabled User', // Column configuration not to be checked
					// 		name: record.name,
					// 	},
					// }),
				};
			},
		},
		created() {
			this.apiFacilitatorList().then(()=>{
				this.apiBlackListQueryList()
			})
		}
	};
</script>

<style scoped>

</style>
